<template>
  <div class="flex items-center h-13 py-5 px-4">
    <a-tooltip
      v-for="(item, index) in alignOptions"
      :key="item.value"
      :title="item.tooltip"
    >
      <div
        class="p-[6px] opacity-30 hover:opacity-100"
        :class="{
          ' !opacity-100': value == item.value && !disabled,
          ' ml-5': index > 0,
          ' attr-disabled': disabled
        }"
        @click="() => !disabled && onClick(item.value)"
      >
        <Icon :icon="item.icon" :width="20" :height="20" fill="none" />
      </div>
    </a-tooltip>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (event: 'change', val: boolean): void;
}>();

defineProps({
  value: {
    type: Boolean,
    required: true
  },
  disabled: {
    type: Boolean,
    required: false
  }
});

const alignOptions: {
  icon: string;
  tooltip: string;
  value: boolean;
}[] = [
  // 需求修改：只保留固定尺寸
  {
    icon: 'width-auto.svg',
    value: true,
    tooltip: '自适应'
  },
  {
    icon: 'width-fixed.svg',
    value: false,
    tooltip: '固定尺寸'
  }
];

const onClick = (val: boolean) => {
  emit('change', val);
};
</script>
